// Crew Package entry (docs/crew-package-brief.md): where a signed-in user belongs. The crew identity is independent of any
// yacht: a crew member whose yacht login was turned off or removed has no yacht config any more, but still has a crew profile
// (supabase/migrations/20261024_crew_package.sql) - they go to /crew, never to an empty yacht app.
// Pure: no React, no browser.

// state: { user, config, loading } from useAuth; profile: undefined = not asked yet, null = none, else the profile id
// -> 'yacht' (the app as today) | 'wait' (asking whether there is a crew profile) | 'crew' (send to /crew)
//    | 'none' (signed in, no vessel, no company, no crew login and no crew profile: the "no vessel" screen - never the
//      app shell, which would treat the login as a Captain with empty lists)
export function crewHome({ user, config, loading } = {}, profile) {
  if (loading || !user || config) return 'yacht'
  if (profile === undefined) return 'wait'
  return profile ? 'crew' : 'none'
}

// should the app ask the database for a crew profile? (only for a signed-in user with no yacht config)
export const needsProfileCheck = ({ user, config, loading } = {}) => !loading && !!user && !config

// the tabs of the crew app (mobile first: bottom bar), from the heycaptain-crew brief
export const CREW_TABS = [
  { id: 'home', label: 'Home' },
  { id: 'rest', label: 'Rest' },
  { id: 'sea', label: 'Sea time' },
  { id: 'certs', label: 'Certs' },
  { id: 'more', label: 'More' },
]
export const tabFromPath = pathname => {
  const id = String(pathname || '').replace(/^\/crew\/?/, '').split('/')[0]
  return CREW_TABS.some(t => t.id === id) ? id : 'home'
}

// the open membership = the yacht the person is on now (verified first, newest start)
export function currentMembership(memberships) {
  return (memberships || []).filter(m => !m.end_date)
    .sort((a, b) => (b.verified - a.verified) || String(b.start_date).localeCompare(String(a.start_date)))[0] || null
}

// the database answer -> what the crew app says (the migration not run yet / not a crew login / other)
export function crewError(err) {
  const m = String((err && err.message) || err || '')
  if (/Not a crew login/i.test(m)) return 'The Crew Package is for crew members. Ask your Captain for a crew login.'
  if (/crew_sync_me|crew_my_profile_id|crew_profiles/.test(m) && /does not exist|not find|schema cache/i.test(m)) return 'The Crew Package is not set up on this server yet.'
  return m || 'Something went wrong'
}
